import request from "../../helpers/request";

export const toggleUserStatus = async (id: number, ativo: boolean) => {
  const url = `/Usuario/AlterarStatus/${id}?ativo=${ativo}`;
  const response = await request({ url, method: "put" });
  return response.data;
};
